import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Skeleton,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as UncheckedIcon,
} from '@mui/icons-material';
import { useGetFacilities } from '@/api/hooks/facilities/useGetFacilities';

const FacilityPermissionsDropdown = ({
  selectedFacilities = [],
  permissions = {},
  selectedFacility,
  onFacilityChange,
  organizationId = null,
  label = 'Configure Permissions For',
  ...props
}) => {
  const { facilities, loading } = useGetFacilities({
    organizationId,
    allColumns: true,
  });

  if (loading) {
    return (
      <Box sx={{ mb: 2 }}>
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Box>
    );
  }

  return (
    <FormControl
      variant='outlined'
      size='small'
      fullWidth
      sx={{ mb: 2 }}
      {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedFacility}
        onChange={(e) => onFacilityChange?.(e.target.value)}
        label={label}>
        {selectedFacilities.map((facilityId) => {
          const facilityObj = facilities.find((f) => f.id == facilityId);
          const facilityName = facilityObj?.name || `Facility ${facilityId}`;
          const hasPermissions =
            permissions[facilityId] &&
            Object.keys(permissions[facilityId]).length > 0;
          return (
            <MenuItem key={facilityId} value={facilityId}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {facilityName}
                {hasPermissions ? (
                  <CheckCircleIcon
                    sx={{ color: 'success.main', fontSize: 20 }}
                  />
                ) : (
                  <UncheckedIcon sx={{ color: 'grey.400', fontSize: 20 }} />
                )}
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default FacilityPermissionsDropdown;
